// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DZSpr","fullView":"styles_fullView__gDANo"};